module.exports = __webpack_public_path__ + "static/media/copyright-prague.fb2d158f.webp";